import React, { useState} from 'react';
import PropTypes from 'prop-types';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import {  Warning, Filter, File, FishIcon, Arrow, SendWhite} from '../../assets/icons';
import { useNavigate } from 'react-router-dom';
import { casesApi } from '../../network/apis/cases';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SymptomSelector from './SymptomSelector';


const NewCaseModal = ({
    setShowNewCaseForm,
    farms,
    setCases,
    cases,
}) => {

    const navigate = useNavigate();
    // const caseFormRef = useRef(null);

    // const handleAddSymptom = () => {
    //     if (caseForm.currentSymptom?.trim()) {
    //         setCaseForm(prev => ({
    //             ...prev,
    //             symptoms: [...prev.symptoms, prev.currentSymptom.trim()],
    //             currentSymptom: ''
    //         }));
    //     }
    // };
    
    const removeSymptom = (index) => {
        setCaseForm({
            ...caseForm,
            symptoms: caseForm.symptoms.filter((_, i) => i !== index)
        });
    };
    // const [title, setTitle] = useState('');
    const [formStep, setFormStep] = useState(1);
    const [formErrors, setFormErrors] = useState({});
    const [attemptedNextStep, setAttemptedNextStep] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const totalSteps = 3;
    // const [currentSymptom, setCurrentSymptom] = useState('');
    const [caseForm, setCaseForm] = useState({
        title: '',
        description: '',
        symptoms: [],
        affectedPopulation: '',
        waterParameters: {
            temperature: '',
            pH: '',
            oxygen: '',
            ammonia: '',
            alkalinity: '',
            nitirite: '',
        },
        images: [],
        videos: [],
        priority: 'MEDIUM',
        farmId: ''
    });

    const handleSubmitCase = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Validate all steps before submission
        let allErrors = {};
        
        for (let i = 1; i <= totalSteps; i++) {
            const stepErrors = validateCurrentStep(i);
            allErrors = { ...allErrors, ...stepErrors };
        }
        
        setFormErrors(allErrors);
        
        if (Object.keys(allErrors).length > 0) {
            // If there are errors, show them and prevent submission
            setAttemptedNextStep(true);
            
            // Go to the first step with errors
            for (let i = 1; i <= totalSteps; i++) {
                const stepErrors = validateCurrentStep(i);
                if (Object.keys(stepErrors).length > 0) {
                    setFormStep(i);
                    break;
                }
            }
            

         // Show error notification
         toast.error('Please fix the errors before submitting', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
        
        return;
    }

    // Show loading notification
    const loadingToast = toast.loading('Submitting your case...', {
        position: "top-right",
    });

    setIsSubmitting(true);
    caseForm.title = caseForm.symptoms[0]
    caseForm.description = caseForm.symptoms[0]

        try {
            const response = await casesApi.addCase(caseForm); 

            toast.update(loadingToast, {
                render: response.message || 'Case submitted successfully!',
                type: "success",
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
                draggable: true,
            }); 

            setCases([...cases, {
                id: `CS${Date.now()}`,
                ...caseForm,
                dateReported: new Date().toISOString(),
                status: 'open',
                assignedTo: null,
                labResults: 'Pending'
            }]);
            setShowNewCaseForm(false);
            setCaseForm({
                title: '',
                description: '',
                location:'',
                symptoms: [],
                affectedPopulation: [],
                waterParameters: {
                    temperature: '',
                    pH: '',
                    alkalinity:'',
                    dissolved_oxygen: '',
                    ammonia: '',
                    nitrite: ''
                },
                images: [],
                priority: 'MEDIUM',
                farmId: ''
            });
        } catch (error) {
            console.error('Error adding case:', error);
            // Handle error (e.g., show error message)
            toast.update(loadingToast, {
                render: error.response?.data?.message || 'Failed to submit case. Please try again.',
                type: "error",
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
                draggable: true,
            });
        } finally {
            setIsSubmitting(false);
        }
    };
    
    const handleClose = () => {
        if (window.confirm('Are you sure you want to close? Any unsaved changes will be lost.')) {
            setShowNewCaseForm(false);
            // Reset form state when closing
            setCaseForm({
                title: '',
                description: '',
                symptoms: [],
                currentSymptom: '',
                affectedPopulation: '',
                waterParameters: {
                    temperature: '',
                    pH: '',
                    oxygen: '',
                    ammonia: ''
                },
                images: [],
                videos: [],
                priority: 'medium',
                farmId: ''
            });
            setFormStep(1);
        }
    };

    const handleStepSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        setAttemptedNextStep(true);
        
        // Validate current step
        const errors = validateCurrentStep(formStep);
        setFormErrors(errors);
        
        // Only proceed if there are no errors
        if (Object.keys(errors).length === 0) {
            setAttemptedNextStep(false);
            setFormStep(prev => prev + 1);
        } else {
            // Scroll to first error
            const firstErrorField = document.querySelector('.form-input.error');
            if (firstErrorField) {
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    };


const validateCurrentStep = (step) => {
    const errors = {};
    
    if (step === 1) {
        // Basic Information validation
        // if (!caseForm.title.trim()) {
        //     errors.title = "Case title is required";
        // }
        
        // if (!caseForm.description.trim()) {
        //     errors.description = "Description is required";
        // }
        if (caseForm.symptoms.length === 0) {
            errors.symptoms = "Please add at least one sign/observation";
        }
        
        if (!caseForm.farmId) {
            errors.farmId = "Please select a farm or enter location";
        }
    }
    
    // else if (step === 2) {
    //     // Symptoms validation - at least one symptom required
    // }
    
    else if (step === 2) {
        // Population details validation
        if (!caseForm.affectedPonds || caseForm.affectedPonds < 1) {
            errors.affectedPonds = "Number of affected ponds is required";
        }
        
        // Check each pond for required fields
        if (caseForm.pondDetails && caseForm.pondDetails.length > 0) {
            caseForm.pondDetails.forEach((pond, index) => {
                if (!pond.collapsed) { // Only validate visible ponds
                    if (!pond.population) {
                        errors[`pond_${index}_population`] = `Population for Pond ${index + 1} is required`;
                    }
                    
                    if (!pond.mortality) {
                        errors[`pond_${index}_mortality`] = `Mortality for Pond ${index + 1} is required`;
                    }
                    
                    if (!pond.fishAge) {
                        errors[`pond_${index}_fishAge`] = `Fish age for Pond ${index + 1} is required`;
                    }
                    
                    if (!pond.fishType) {
                        errors[`pond_${index}_fishType`] = `Fish type for Pond ${index + 1} is required`;
                    }
                    
                    if (!pond.pondType) {
                        errors[`pond_${index}_pondType`] = `Pond system type for Pond ${index + 1} is required`;
                    }
                    
                    if (!pond.waterSource) {
                        errors[`pond_${index}_waterSource`] = `Water source for Pond ${index + 1} is required`;
                    }
                }
            });
        }
    }
    
    return errors;
};

    // const handleSymptomSubmit = (e) => {
    //     // e.preventDefault();
    //     // e.stopPropagation();
    //     if (caseForm.currentSymptom?.trim()) {
    //         handleAddSymptom();
    //     }
    // };

    const handleSymptomSubmit = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        
        if (caseForm.currentSymptom?.trim()) {
            setCaseForm(prev => ({
                ...prev,
                symptoms: [...prev.symptoms, prev.currentSymptom.trim()],
                currentSymptom: ''  // Clear the currentSymptom after adding
            }));
        }
    };

    const steps = [
        // { label: 'Basic Info', icon: Info },
        { label: 'Observations', icon: Warning },
        { label: 'Parameters', icon: Filter },
        { label: 'Media', icon: File }
    ];

    return (
        <div className="modal-overlay" onClick={(e) => e.target.className === 'modal-overlay' && handleClose()}>
            
            <div className="modal-content case-form" onClick={(e) => e.stopPropagation()}>
                <div className="form-header">
                    <div className="header-top">
                        <h2>
                            <img src={File} className="icon" alt="New Case" />
                            Report New Case
                        </h2>
                        <button 
                            className="close-button" 
                            onClick={handleClose}
                            aria-label="Close modal"
                        >
                            ×
                        </button>
                    </div>
                    <div className="progress-steps">
                        {steps.map((step, i) => (
                            <div 
                                key={i} 
                                className={`step ${formStep > i ? 'completed' : ''} 
                                    ${formStep === i + 1 ? 'active' : ''}`}
                                onClick={() => formStep > i && setFormStep(i + 1)}
                            >
                                <div className="step-content">
                                    <div className="step-number">
                                        {formStep > i ? '✓' : i + 1}
                                    </div>
                                    <div className="step-label">
                                        <img src={step.icon} className="step-icon" alt={step.label} />
                                        {step.label}
                                    </div>
                                </div>
                                {i < steps.length - 1 && <div className="step-connector" />}
                            </div>
                        ))}
                    </div>
                </div>


                <form onSubmit={handleSubmitCase} className="case-form-content">
                    {/* {formStep === 1 && (
                        <div className="form-section">
                            <h3>
                                <img src={Info} className="section-icon" />
                                Basic Information
                            </h3>
                            <div className="priority-selector">
                                    <label>Case Priority</label>
                                <small className="help-text">Select the urgency level of this case</small>
                                    <div className="priority-options">
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-low" 
                                                name="priority" 
                                                value="low"
                                                checked={caseForm.priority.toLowerCase() === 'low'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'LOW'})}
                                            />
                                            <label htmlFor="priority-low">Low</label>
                                        </div>
                                        
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-medium" 
                                                name="priority" 
                                                value="medium"
                                                checked={caseForm.priority.toLowerCase() === 'medium'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'MEDIUM'})}
                                            />
                                            <label htmlFor="priority-medium">Medium</label>
                                        </div>
                                        
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-high" 
                                                name="priority" 
                                                value="high"
                                                checked={caseForm.priority.toLowerCase() === 'high'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'HIGH'})}
                                            />
                                            <label htmlFor="priority-high">High</label>
                                        </div>
                                    </div>
                                </div>
                                <FormInput
                                    label="Case Title" 
                                    value={caseForm.title}
                                    onChange={(e) => setCaseForm({...caseForm, title: e.target.value})}
                                    type="text"
                                    required={true}
                                    placeholder="Enter Case title"
                                    helpText="Be specific about the subject of the issue"
                                    icon={<img src={Title} />}
                                    error={attemptedNextStep && formErrors.title}
                                />
                                <FormInput
                                label="Description"
                                type='textarea'
                                value={caseForm.description}
                                required={true}
                                onChange={(e) => setCaseForm({...caseForm, description: e.target.value})}
                                placeholder="Describe the problem in detail..."
                                error={attemptedNextStep && formErrors.description}
                                 />

                                
                                <FormInput
                                    label="Select Farm"
                                    type="select"
                                    value={caseForm.farmId}
                                    onChange={(e) => {
                                        const selectedFarmId = e.target.value;
                                        const selectedFarm = farms.find(f => f.id === selectedFarmId);
                                        setCaseForm({
                                            ...caseForm, 
                                            farmId: selectedFarmId,
                                            location: selectedFarm?.location || ''
                                        });
                                    }}
                                    required={true}
                                    showHelpText={true}
                                    helpText={["Select an existing farm or click ", <button type="button" key="add-link" className="link-button" onClick={()=> navigate('/farms')}>Add</button>, " to add a new one"]}
                                    error={attemptedNextStep && formErrors.farmId}
                                >
                                    <option value="">-- Select a Farm --</option>
                                    {farms.map(farm => (
                                        <option key={farm.id} value={farm.id}>
                                            {farm.name}
                                        </option>
                                    ))}
                                </FormInput>

                                <FormInput
                                    label="Farm Location"
                                    type="text"
                                    value={caseForm.location}
                                    onChange={(e) => setCaseForm({...caseForm, location: e.target.value})}
                                    required
                                    placeholder="Enter location"
                                    helpText="City, District or GPS coordinates"
                                    disabled={caseForm.farmId !== ''}
                                    error={attemptedNextStep && formErrors.farmId}
                                />
                                

                        </div>
                    )} */}

                    {formStep === 1 && (
                        <div className="form-section symptoms-section">
                            <h3>
                                <img src={Warning} className="section-icon" alt="Symptoms" />
                                Signs & Observation
                            </h3>
                            <div className="priority-selector">
                                    <label>Case Priority</label>
                                <small className="help-text">Select the urgency level of this case</small>
                                    <div className="priority-options">
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-low" 
                                                name="priority" 
                                                value="low"
                                                checked={caseForm.priority.toLowerCase() === 'low'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'LOW'})}
                                            />
                                            <label htmlFor="priority-low">Low</label>
                                        </div>
                                        
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-medium" 
                                                name="priority" 
                                                value="medium"
                                                checked={caseForm.priority.toLowerCase() === 'medium'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'MEDIUM'})}
                                            />
                                            <label htmlFor="priority-medium">Medium</label>
                                        </div>
                                        
                                        <div className="priority-option">
                                            <input 
                                                type="radio" 
                                                id="priority-high" 
                                                name="priority" 
                                                value="high"
                                                checked={caseForm.priority.toLowerCase() === 'high'} 
                                                onChange={() => setCaseForm({...caseForm, priority: 'HIGH'})}
                                            />
                                            <label htmlFor="priority-high">High</label>
                                        </div>
                                    </div>
                                </div>
                            <div className="symptoms-container">
                                {/* <div className="symptoms-input-wrapper">
                                    <FormInput
                                        label="Add Signs/Observation"
                                        value={caseForm.currentSymptom || ''}
                                        // onChange={(e) => setCurrentSymptom(e.target.value)}
                                        onChange={(e) => setCaseForm({
                                            ...caseForm,
                                            currentSymptom: e.target.value
                                        })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                handleSymptomSubmit(e);
                                            }
                                        }}
                                        helpText="Press Enter to add multiple symptoms"
                                        placeholder="Enter a symptom..."
                                        icon={<img src={Add} alt="Add symptom" />}
                                        error={attemptedNextStep && formErrors.symptoms}
                                    />
                                    <Button
                                        type="button"
                                        variant="outline"
                                        text="Add"
                                        onClick={handleSymptomSubmit}
                                    />
                                </div> */}

<label className="symptom-selector-label">Add Signs/Observation</label>
<SymptomSelector
    currentSymptom={caseForm.currentSymptom || ''}
    onChange={(e) => {
        setCaseForm({
            ...caseForm,
            currentSymptom: e.target.value
        });
    }}
    onAddSymptom={handleSymptomSubmit}
/>
                                
                                {/* <div className="symptoms-tags-container">
                                    {caseForm.symptoms.length > 0 ? (
                                        <div className="symptoms-tags">
                                            {caseForm.symptoms.map((symptom, index) => (
                                                <span key={index} className="symptom-tag">
                                                    {symptom}
                                                    <button 
                                                        type="button" 
                                                        onClick={() => removeSymptom(index)}
                                                        className="remove-symptom"
                                                        aria-label={`Remove ${symptom}`}
                                                    >
                                                        ×
                                                    </button>
                                                </span>
                                            ))}
                                        </div>
                                    ) : (
                                        <p className="no-symptoms">No signs added yet</p>
                                    )}
                                </div>
                                {attemptedNextStep && formErrors.symptoms && (
                                    <div className="error-message symptoms-error">
                                        {formErrors.symptoms}
                                    </div>
                                )} */}

<div className="symptoms-tags-container">
                {caseForm.symptoms.length > 0 ? (
                    <div className="symptoms-tags">
                        {caseForm.symptoms.map((symptom, index) => (
                            <span key={index} className="symptom-tag">
                                {symptom}
                                <button 
                                    type="button" 
                                    onClick={() => removeSymptom(index)}
                                    className="remove-symptom"
                                    aria-label={`Remove ${symptom}`}
                                >
                                    ×
                                </button>
                            </span>
                        ))}
                    </div>
                ) : (
                    <p className="no-symptoms">No signs added yet</p>
                )}
            </div>
            {attemptedNextStep && formErrors.symptoms && (
                <div className="error-message symptoms-error">
                    {formErrors.symptoms}
                </div>
            )}
        </div>
                                
                                <FormInput
                                    label="Select Farm"
                                    type="select"
                                    value={caseForm.farmId}
                                    onChange={(e) => {
                                        const selectedFarmId = e.target.value;
                                        const selectedFarm = farms.find(f => f.id === selectedFarmId);
                                        setCaseForm({
                                            ...caseForm, 
                                            farmId: selectedFarmId,
                                            location: selectedFarm?.location || ''
                                        });
                                    }}
                                    required={true}
                                    showHelpText={true}
                                    helpText={["Select an existing farm or click ", <button type="button" key="add-link" className="link-button" onClick={()=> navigate('/farms')}>Add</button>, " to add a new one"]}
                                    error={attemptedNextStep && formErrors.farmId}
                                >
                                    <option value="">-- Select a Farm --</option>
                                    {farms.map(farm => (
                                        <option key={farm.id} value={farm.id}>
                                            {farm.name}
                                        </option>
                                    ))}
                                </FormInput>
                                <div className="add-farm-button">
                                    <Button
                                        type="button"
                                        variant="outline"
                                        text="Add New Farm"
                                        onClick={() => navigate('/farms')}
                                    />
                                </div>
                        </div>
                    )}

                    {formStep === 2 && (
                        <div className="form-section">
                            <h3>
                                <img src={Filter} className="section-icon" alt="" />
                                Affected Population Details
                            </h3>
                            <div className="population-section">
                                    <div className="form-row">
                                        <div className="form-col">
                                            <FormInput
                                                label="Number of Affected Ponds"
                                                type="number"
                                                value={caseForm.affectedPonds || ""}
                                                onChange={(e) => {
                                                    const value = Math.max(1, parseInt(e.target.value) || 0);
                                                    setCaseForm({
                                                        ...caseForm, 
                                                        affectedPonds: value,
                                                        pondDetails: Array(value).fill().map((_, i) => 
                                                            caseForm.pondDetails?.[i] || {
                                                                population: '',
                                                                mortality: '',
                                                                fishAge: '',
                                                                fishType: '',
                                                                pondType: '',
                                                                waterSource: '',
                                                                previousTreatment: ''
                                                            }
                                                        )
                                                    });
                                                }}
                                                min="1"
                                                required
                                                icon={<img src={FishIcon} alt="Ponds" />}
                                                helpText="Enter the number of affected ponds"
                                                showLabel={true}
                                                error={attemptedNextStep && formErrors.affectedPonds}
                                            />
                                        </div>
                                    </div>

                                    {caseForm.affectedPonds > 0 && caseForm.pondDetails?.map((pond, index) => (
                                        <div key={index} className="pond-details">
                                            <div className="pond-header">
                                                <h4>Pond {index + 1} Details</h4>
                                                {caseForm.affectedPonds > 1 && (
                                                    <button 
                                                        type="button" 
                                                        className="collapse-pond"
                                                        onClick={() => {
                                                            // Toggle collapse state
                                                            const newPondDetails = [...caseForm.pondDetails];
                                                            newPondDetails[index].collapsed = !newPondDetails[index].collapsed;
                                                            setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                        }}
                                                    >
                                                        {pond.collapsed ? '▼' : '▲'}
                                                    </button>
                                                )}
                                            </div>

                                            {!pond.collapsed && (
                                                <>
                                                    <div className="form-row">
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Population in Pond"
                                                                type="number"
                                                                value={pond.population}
                                                                onChange={(e) => {
                                                                    const value = Math.max(0, parseInt(e.target.value) || 0);
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].population = value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                min="0"
                                                                required
                                                                helpText="Total number of fish in this pond"
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_population`]}
                                                            />
                                                        </div>
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Weekly Mortality"
                                                                type="number"
                                                                value={pond.mortality}
                                                                onChange={(e) => {
                                                                    const value = Math.min(100, Math.max(0, parseFloat(e.target.value) || 0));
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].mortality = value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                min="0"
                                                                required
                                                                helpText="Estimated mortality percentage per week"
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_mortality`]}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="form-row">
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Fish Age (weeks)"
                                                                type="number"
                                                                value={pond.fishAge}
                                                                onChange={(e) => {
                                                                    const value = Math.max(0, parseInt(e.target.value) || 0);
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].fishAge = value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                min="0"
                                                                required
                                                                helpText="Age of the fish in weeks"
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_fishAge`]}
                                                            />
                                                        </div>
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Fish Type"
                                                                type="select"
                                                                value={pond.fishType}
                                                                onChange={(e) => {
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].fishType = e.target.value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                required
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_fishType`]}
                                                            >
                                                                <option value="">-- Select Fish Type --</option>
                                                                <option value="tilapia">Tilapia</option>
                                                                <option value="catfish">Catfish</option>
                                                                <option value="carp">Carp</option>
                                                                <option value="trout">Trout</option>
                                                                <option value="salmon">Salmon</option>
                                                                <option value="other">Other</option>
                                                            </FormInput>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="form-row">
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Pond System"
                                                                type="select"
                                                                value={pond.pondType}
                                                                onChange={(e) => {
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].pondType = e.target.value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                required
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_pondType`]}
                                                            >
                                                                <option value="">-- Select Pond System --</option>
                                                                <option value="earthen">Earthen Pond</option>
                                                                <option value="concrete">Concrete Tank</option>
                                                                <option value="cage">Cage Culture</option>
                                                                <option value="ras">Recirculating Aquaculture System (RAS)</option>
                                                                <option value="biofloc">Biofloc System</option>
                                                                <option value="other">Other</option>
                                                            </FormInput>
                                                        </div>
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Water Source"
                                                                type="select"
                                                                value={pond.waterSource}
                                                                onChange={(e) => {
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].waterSource = e.target.value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                required
                                                                showLabel={true}
                                                                error={attemptedNextStep && formErrors[`pond_${index}_waterSource`]}
                                                            >
                                                                <option value="">-- Select Water Source --</option>
                                                                <option value="river">River/Stream</option>
                                                                <option value="well">Borehole/Well</option>
                                                                <option value="rain">Rainwater</option>
                                                                <option value="municipal">Municipal Supply</option>
                                                                <option value="spring">Spring</option>
                                                                <option value="other">Other</option>
                                                            </FormInput>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="form-row">
                                                        <div className="form-col">
                                                            <FormInput
                                                                label="Previous Treatments (if any)"
                                                                type="textarea"
                                                                value={pond.previousTreatment}
                                                                onChange={(e) => {
                                                                    const newPondDetails = [...caseForm.pondDetails];
                                                                    newPondDetails[index].previousTreatment = e.target.value;
                                                                    setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                }}
                                                                placeholder="Describe any previous treatments applied"
                                                                showLabel={true}
                                                                helpText="Include treatment name, dosage, and dates if known"
                                                                error={attemptedNextStep && formErrors[`pond_${index}_previousTreatment`]}
                                                            />
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="pond-parameters">
                                                        <h5>Water Parameters for Pond {index + 1}</h5>
                                                        <div className="form-row">
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="Temperature (°C)"
                                                                    type="number"
                                                                    value={pond.temperature || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].temperature = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    step="0.1"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_temperature`]}
                                                                />
                                                            </div>
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="pH"
                                                                    type="number"
                                                                    value={pond.pH || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].pH = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    max="14"
                                                                    step="0.1"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_pH`]}
                                                                />
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="form-row">
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="Dissolved Oxygen (mg/L)"
                                                                    type="number"
                                                                    value={pond.oxygen || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].oxygen = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    step="0.1"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_oxygen`]}
                                                                />
                                                            </div>
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="Ammonia (mg/L)"
                                                                    type="number"
                                                                    value={pond.ammonia || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].ammonia = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    step="0.01"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_ammonia`]}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-row">
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="Alkalinity"
                                                                    type="number"
                                                                    value={pond.alkalinity || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].alkalinity = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    max="14"
                                                                    step="0.1"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_alkalinity`]}
                                                                />
                                                            </div>
                                                            <div className="form-col">
                                                                <FormInput
                                                                    label="Nitrite (mg/L)"
                                                                    type="number"
                                                                    value={pond.nitrite || ""}
                                                                    onChange={(e) => {
                                                                        const newPondDetails = [...caseForm.pondDetails];
                                                                        newPondDetails[index].nitrite = e.target.value;
                                                                        setCaseForm({...caseForm, pondDetails: newPondDetails});
                                                                    }}
                                                                    min="0"
                                                                    step="0.01"
                                                                    showLabel={true}
                                                                    error={attemptedNextStep && formErrors[`pond_${index}_nitrite`]}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )} 

                                        </div>
                                        ))}
                                </div>
                        </div>
                    )}

                    {formStep === 3 && (
                        <div className="form-section">
                            <h3>
                                <img src={File} className="section-icon" alt="" />
                                Media Attachments
                            </h3>
                            <div className="">
                                <FormInput
                                    label="Images"
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    onChange={(e) => setCaseForm({ ...caseForm, images: e.target.files })}
                                    icon={<img src={File} alt="" />}
                                    showLabel
                                />
                            </div>
                        </div>
                    )}


                <div className="form-navigation">
                    <small className="step-indicator">
                        Step {formStep} of {totalSteps}
                    </small>
                    <div className="nav-buttons">
                        {formStep > 1 ? (
                            <Button
                                text="Previous"
                                variant="outline"
                                icon={<img src={Arrow} alt="" className='arrow_left' />}
                                onClick={() => setFormStep(prev => prev - 1)}
                            />
                        ) : (
                            <div className="nav-spacer" />
                        )}
                        {formStep < totalSteps ? (
                            <Button
                                type="button"
                                text="Next"
                                variant="primary"
                                icon={<img src={Arrow} alt="" className='arrow_right' />}
                                onClick={handleStepSubmit}
                            />
                        ) : (
                            <Button
                                text={isSubmitting ? "Submitting..." : "Submit Case"}
                                type="button"
                                variant="primary"
                                icon={!isSubmitting && <img src={SendWhite} alt="Submit" />}
                                onClick={handleSubmitCase}
                                loading={isSubmitting}
                                disabled={isSubmitting}
                            />
                        )}
                    </div>
                </div>
                    </form>
            </div>
        </div>
        );
};

NewCaseModal.propTypes = {
    setShowNewCaseForm: PropTypes.func.isRequired,
    farms: PropTypes.array.isRequired,
    setCases: PropTypes.func.isRequired,
    cases: PropTypes.array.isRequired,
};

export default NewCaseModal;